<template>
  <div class="px-5 py-8">
    <master-form />
  </div>
</template>
<script>
import MasterForm from '@/modules/teacher-support/components/index.vue';

export default {
  components: { MasterForm },
};
</script>
